<template>
  <div class="f-h basic-gray-section">
    <h1 class="basic-blue-title">
      {{ $t("message.GW_INDICATORS") }}
    </h1>
    <div class="f-h-below-title">
      <div>
        {{ $t('message.GW_INDICATORS_MOVED_TO_SETTINGS') }}
      </div>
      <RouterLink class="option-button" to="/settings/indicators">
        {{ $t('message.SETTINGS') }}
      </RouterLink>
    </div>
  </div>
</template>

<script>
/**
 * WARNING: To be removed in next releases
 * Display a list of editable GW indicators.
 *
 * GW indicators behave much like DMP indicators, they have a name and an objective (min or max)
 * But the way values are attached to it differs :
 * - An indiator is attached to a checklist item, thus there can be one value per checklist item
 * which can lead to multiple values a day (DMP indicators only allow one value per day)
 * - All teams that have a equal or higher hierarchyLevel as the team that created the
 * indicator may use it for their own field tours and thus add values to it.
 */

export default {
  name: 'GwIndicators',
};
</script>

<style lang="scss">
.gw-indicators {
  .f-h-below-title {
    box-sizing: border-box;
    padding: 1em;
  }
}
</style>
